import axios from "axios";

let baseURL = window.API_BASE_URL;
let axiosApi = axios.create({ baseURL });
let axiosApiAnonymous = axios.create({ baseURL });
let axiosApiApp = axios.create({ baseURL });

export let setAuthHeader = (token) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
export let setAuthHeaderApp = (token) => {
  axiosApiApp.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export default axiosApi;

export class APITeleMedicinaService {
  lojaUrlSlug = null;

  constructor() {}

  getUrl(urlBase) {
    baseURL = urlBase;
    axiosApi = axios.create({ baseURL });
    axiosApiAnonymous = axios.create({ baseURL });
    axiosApiApp = axios.create({ baseURL });

    axiosApiApp.defaults.headers.common["Content-Type"] = "application/json";

    setAuthHeaderApp(sessionStorage.getItem("token"));
    setAuthHeader(sessionStorage.getItem("token"));
  }

  getCep(cep) {
    this.getUrl(window.API_BASE_URL);
    const url = `/v2/microapp/app/util/consulta-cep/${cep}`;
    return axiosApi.get(url).then((response) => response.data);
  }
  getStore1(urlSlug) {
    this.getUrl(window.API_BASE_URL);
    this.lojaUrlSlug = urlSlug;
    const url = `/v3/wapp/marketplace/listar-produtos/${this.lojaUrlSlug}`;
    return axiosApiAnonymous.get(url).then((response) => {
      const token = response.headers.authorization.replace("Bearer ", "");
      setAuthHeader(token);
      return response.data;
    });
  }
  getStore(urlSlug, lojaId, categoriaId) {
    this.getUrl(window.API_BASE_URL);
    this.lojaUrlSlug = urlSlug;
    const filters =
      lojaId || categoriaId
        ? `?${lojaId ? `lojaId=${lojaId}` : ""}${
            categoriaId ? `&categoriaId=${categoriaId}` : ""
          }`
        : "";
    const url = `/v3/wapp/marketplace/listar-produtos/${this.lojaUrlSlug}${filters}`;

    return axiosApiAnonymous.get(url).then((response) => {
      return response.data;
    });
  }
  getProdutosFiltroTexto(urlSlug, lojaId, filtroTexto) {
    this.getUrl(window.API_BASE_URL);
    this.lojaUrlSlug = urlSlug;
    const filters =
      lojaId || filtroTexto
        ? `?${lojaId ? `lojaId=${lojaId}` : ""}${
            filtroTexto ? `&pesquisaProduto=${filtroTexto}` : ""
          }`
        : "";
    const url = `/v3/wapp/marketplace/listar-produtos/${this.lojaUrlSlug}/filtro${filters}`;

    return axiosApiAnonymous.get(url).then((response) => {
      return response.data;
    });
  }

  obterConfig(hostnameUrl) {
    this.getUrl(window.API_BASE_URL);
    const url = "config/" + hostnameUrl + "_config.json";
    return axios
      .create()
      .get(url)
      .then((response) => response.data);
  }

  obterListaOcupacao() {
    const url = "config/ocupacao.json";
    return axios
      .create()
      .get(url)
      .then((response) => response.data);
  }

  obterPagina(pagina) {
    this.getUrl(window.API_BASE_URL);
    const url = `paginas/${window.APP_ORIGIN}/${pagina}.html`;
    return axios
      .create()
      .get(url)
      .then((response) => response.data);
  }

  obterEspecialidades(){
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/app/planos/servico/telemedicina/agendamento/especialidades`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterDias(idEspecialidadeMedica, data){
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/app/planos/servico/telemedicina/agendamento/datas?idEspecialidadeMedica=${idEspecialidadeMedica}&anoMes=${data}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }

  obterHorarios(idEspecialidadeMedica, data){
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/app/planos/servico/telemedicina/agendamento/horarios?idEspecialidadeMedica=${idEspecialidadeMedica}&data=${data}`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  
  agendarConsulta(obj){
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/app/planos/servico/telemedicina/agendamento`;
    return axiosApiApp
    .post(url, obj)
    .then((response) => response.data);
  }
  
  obterAgendamentos(){
    this.getUrl(window.API_BASE_URL);
    const url = `v1/app/planos/servico/telemedicina/cliente/agendamentos`;
    return axiosApiApp.get(url).then((response) => response.data);
  }
  
  cancelarAgendamento(idAgendamento){
    this.getUrl(window.API_BASE_URL);
    const url = `v1/app/planos/servico/telemedicina/agendamento/cancelar?idAgendamento=${idAgendamento}`;
    return axiosApiApp.put(url).then((response) => response.data);
  }
  
  reagendarConsulta(obj){
    this.getUrl(window.API_BASE_URL);
    const url = `/v1/app/planos/servico/telemedicina/reagendar`;
    return axiosApiApp
    .post(url, obj)
    .then((response) => response.data);
  }
}
